import { IsDefined, IsString, ValidateNested } from 'class-validator';
import { BulkImportConfigDto } from './bulk-import-data.dto';

export class CreateBulkImportDto {
    @IsDefined()
    @ValidateNested()
    bulkImportConfigDto: BulkImportConfigDto;

    @IsDefined()
    @IsString()
    name: string;

    constructor(iCreateBulkImport: CreateBulkImportDto) {
        this.bulkImportConfigDto = new BulkImportConfigDto(iCreateBulkImport.bulkImportConfigDto);
        this.name = iCreateBulkImport.name;
    }
}
